import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { Typography } from '../Typography';

export const NoResultsFound = () => (
  <Grid container direction='column' alignContent='center' alignItems='center'>
    <Grid>
      <Box padding='32px 0 8px 0'>
        <Typography variant='h3' color='textPrimary'>
          No Results Found
        </Typography>
      </Box>
    </Grid>
    <Grid>
      <Box padding='14px 0'>
        <Typography>
          Try adjusting your search or filter to find what you are looking for.
        </Typography>
      </Box>
    </Grid>
  </Grid>
);
